.swipeContainer {
  display: flex;
  flex-direction: row;
  gap: var(--sizes-spacing-6);
  width: 100%;
}

@media (min-width: 1160px) {
  .swipeContainer {
    overflow: visible;
  }
}

@media (max-width: 1159px) {
  .swipeContainer {
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scroll-snap-type: x mandatory;

    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .swipeContainer::-webkit-scrollbar {
    display: none;
  }
}

.swipeCard {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 300px;
  padding: var(--sizes-spacing-8);
  background: rgba(255, 255, 255, 1);
  border: 1px solid var(--palette-border-neutral-subtle);
  border-radius: var(--sizes-radius-2xl);
  box-sizing: border-box;
}

@media (max-width: 1159px) {
  .swipeCard {
    padding: var(--sizes-spacing-8);
    gap: var(--sizes-spacing-3);
  }
}
